const diet = { 1: "Veg", 2: "Non-Veg", 3: "Vegan", 4: "Egg" };
const dietToFoodTypeId = { Veg: 1, "Non-veg": 2, Vegan: 3, Egg: 4 };
const dietTypeToFoodTasteId = {
  Spicy: 1,
  Bestseller: 2,
  "Gluten-Free": 3,
  Sweet: 4,
  "No Onion Garlic": 5,
  New: 6,
  "Chef Special": 7,
  Jain: 8,
  Dry: 9,
  Gravy: 10,
};

const foodTasteLabels = {
  1: "🌶️ Spicy",
  2: "⭐ Bestseller",
  3: "Gluten-Free",
  4: "Sweet",
  5: "No Onion Garlic",
  6: "✨ New",
  7: "👑 Chef Special",
  8: "🌿 Jain",
  9: "🥙 Dry",
  10: "🍲 Gravy",
};

// const dietTaste = { 1: "Spicy", 2: "Bestseller", 3: "Gluten-Free", 4: "Sweet", 5: "No Onion Garlic", 6: "New",
//   7:"Chef Special", 8:"Jain", 9:"Dry", 10:"Gravy"};

export { dietToFoodTypeId, diet, foodTasteLabels, dietTypeToFoodTasteId };
